// extracted by mini-css-extract-plugin
export default {"Pages":"Global_Pages__U-Mgg","Toastify__toast--success":"Global_Toastify__toast--success__2I2+g"};